import {InputPref} from '../../dedicated-biller/dedicated-biller/dedicated-biller.model';

export class Biller {
  inputPreferences: InputPref[];

  biller_id: string;
  service_name?: any;
  created_time: Date;
  biller_name: string;
  full_name: string;
  mobile: string;
  email_id: string;
  status: number;
  biller_code?: any;
  commission_percentage: number;
  commission_flat: number;
  cust_type: string;
  service_img?: any;
  biller_img: string;
  is_fetch_bill_mandate: boolean;
  is_fetch_bill_available: boolean;
  is_amt_fixed: boolean;
  is_activate: boolean;
  is_acpt_quickpay: boolean;
  is_acpt_any_amt: boolean;
  is_offline: boolean;
  expire_time?: any;
  input_preference: string[];
  eservice_config: EserviceConf;
}

export class EserviceConf {
  login_url: string;
  param_1: string;
  param_2: string;
}

export class BillerService {
  service_id: number;
  service_name: string;
  service_img: string;
  service_type: string;
  biller: Biller[];
}

export class ServiceResponse {
  response: string;
  reason: string;
  biller_services: BillerService[];
}

export class ReviewResponse {
  status: string;
  message: string;
  summary: Summary[];
  review: Review[];
}

export class Summary {
  id: number;
  services: string;
  banks: string;
  billers: string;
  transactions: string;
  transaction_amount: string;
}

export class Review {
  id: number;
  name: string;
  address: string;
  comment: string;
  image_url: string;
  timestamp: string;
}

export class EducationalInstitute {
  instituteName: string;
  instituteId: string;
}


// WEBPACK FOOTER //
// ./src/app/payment/services/service-response.ts